import React from "react";
import {BrowserRouter as Router,Routes,Route} from "react-router-dom";
import Login from "./pages/Login";
import Forgotpassword from "./pages/Forgot-password";
import Dashboard from "./pages/Dashboard";
import Manageorders from "./pages/Manage-orders";
import Customers from "./pages/Customers";
import Managedrivers from "./pages/Drivers";
import Manageservicearea from "./pages/Service-area";
import Manageprices from "./pages/Price";
import Changepassword from "./pages/Change-password";
import ResetPassword from "./pages/Reset-password";
import InvalidToken from "./pages/ExtraScreen/InvalidToken";
import Thankyou from "./pages/ExtraScreen/Thankyou";
import LastLocation from "./pages/LastLocation/GoogleMapWithMarkers";
import PrivacyPolicy from "./pages/PrivacyPolicies";
import { ProtectedRoute } from "./Routes/ProtectedRoutes";
import Error from "./pages/ErrorPage/Error";
function App() {
    return (
        <Router>
            <Routes>
                <Route exact path="/" element={<Login />} />
                <Route path="/forgot-password" element={<Forgotpassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/thank-you" element={<Thankyou />} />
                <Route path="/invalid-token" element={<InvalidToken />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/manage-orders" element={<Manageorders />} />
                <Route path="/customers" element={<Customers />} />
                <Route path="/manage-drivers" element={<Managedrivers />} />
                <Route path="/manage-service-area" element={<Manageservicearea />} />
                <Route path="/manage-price" element={<Manageprices />} />
                <Route path="/change-password" element={<Changepassword />} />
                <Route path="/last-location" element={<LastLocation />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                {/* <Route exact path="*" element={<Login />} /> */}
                <Route exact path="*" element={<Error />} />
            </Routes>
        </Router>        
        
    );
}
 
export default App;